import { atom } from 'jotai';

interface TileSliderState {
    /**
     * Enable the tile slider on all tiles.
     */
    enableTileSliderAll: boolean;
    /**
     * Enable the tile slider on product tiles.
     */
    enableTileSliderProduct: boolean;
    /**
     * Enable the tile slider on project tiles.
     */
    enableTileSliderProject: boolean;
    /**
     * Disable the tile slider due to the experiment variant of the
     * `tile-slider-disabled` A/B test.
     * @see https://app.growthbook.io/experiment/exp_19g61smgrccb3g
     */
    disableTileSliderABTest: boolean;
}

/**
 * Atom to control whether tiles should render a tile slider (image carousel)
 * if there is more than one image.
 *
 * If a tile type has more than one setting that affects it, all of the settings
 * must be enabled to enable the setting, e.g. both `enableTileSliderProduct`
 * and `enableTileSliderAll` must be enabled to enable the tile slider on product tiles.
 */
export const tileSliderAtom = atom<TileSliderState>({
    enableTileSliderAll: true,
    enableTileSliderProduct: true,
    enableTileSliderProject: true,
    disableTileSliderABTest: false,
});
